var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_user",
    transform: "translate(-1085.000000, -31.000000)",
    stroke: "#D0021B",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75,22.3214286 L6.25,22.3214286 C5.26428571,22.3214286 4.46428571,21.5214286 4.46428571,20.5357143 L4.46428571,4.46428571 L20.5357143,4.46428571 L20.5357143,20.5357143 C20.5357143,21.5214286 19.7357143,22.3214286 18.75,22.3214286 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82142857,16.9642857 L9.82142857,9.82142857",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1785714,16.9642857 L15.1785714,9.82142857",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.892857143,4.46416667 L24.1071429,4.46416667",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1785714,0.892738095 L9.82142857,0.892738095 C8.83571429,0.892738095 8.03571429,1.6927381 8.03571429,2.67845238 L8.03571429,4.46416667 L16.9642857,4.46416667 L16.9642857,2.67845238 C16.9642857,1.6927381 16.1642857,0.892738095 15.1785714,0.892738095 Z",
    id: "Stroke-9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c129ab212851b0d15e6cf8f052fe81df.svg";
export { ForwardRef as ReactComponent };